export const SET_TOUR_ACTIVE = 'IntroTour/SET_TOUR_ACTIVE';

export function setTourActive(active) {
  return {
    type: SET_TOUR_ACTIVE,
    payload: { active }
  };
}
